export default __webpack_public_path__ + "static/media/outbreak.58f5e520.jpg";